const Joi = require("joi");

const SecurityQuestionSchema = (data) => {

    const schema = Joi.object({
        questionOne: Joi.number()
            .required()
            .messages({
                "any.required": "Select Security Question 1.",
                "number.base": "Select Security Question 1.",
            }),

        questionTwo: Joi.number()
            .required()
            .messages({
                "any.required": "Select Security Question 2.",
                "number.base": "Select Security Question 2.",
            }),
        questionThree: Joi.number()
            .required()
            .messages({
                "any.required": "Select Security Question 3.",
                "number.base": "Select Security Question 3.",
            }),
        answerOne: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": "Please enter your answer 1.",
                "any.required": "Please enter your answer 1.",
            }),
        answerTwo: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": "Please enter your answer 2.",
                "any.required": "Please enter your answer 2.",
            }),
        answerThree: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": "Please enter your answer 3.",
                "any.required": "Please enter your answer 3.",
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = SecurityQuestionSchema;
